/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BulkUploadDataResponse,
    BulkUploadDataResponseFromJSON,
    BulkUploadDataResponseToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelToJSON,
    Country,
    CountryFromJSON,
    CountryToJSON,
    CountryFormConfiguration,
    CountryFormConfigurationFromJSON,
    CountryFormConfigurationToJSON,
    CountryListBusinessDataResponse,
    CountryListBusinessDataResponseFromJSON,
    CountryListBusinessDataResponseToJSON,
    GeoFormData,
    GeoFormDataFromJSON,
    GeoFormDataToJSON,
    Location,
    LocationFromJSON,
    LocationToJSON,
    LocationListBusinessDataResponse,
    LocationListBusinessDataResponseFromJSON,
    LocationListBusinessDataResponseToJSON,
    Region,
    RegionFromJSON,
    RegionToJSON,
    RegionFormConfiguration,
    RegionFormConfigurationFromJSON,
    RegionFormConfigurationToJSON,
    RegionListBusinessDataResponse,
    RegionListBusinessDataResponseFromJSON,
    RegionListBusinessDataResponseToJSON,
    RuleRouteRestrictionPointType,
    RuleRouteRestrictionPointTypeFromJSON,
    RuleRouteRestrictionPointTypeToJSON,
    StationOrLocationListBusinessDataResponse,
    StationOrLocationListBusinessDataResponseFromJSON,
    StationOrLocationListBusinessDataResponseToJSON,
    ValidationErrors,
    ValidationErrorsFromJSON,
    ValidationErrorsToJSON,
} from '../models';

export interface ApiCommonGeographyBuildRuleFormDataGeoGetRequest {
    code?: string;
    pointType?: RuleRouteRestrictionPointType;
}

export interface ApiCommonGeographyListCountriesByRegionGetRequest {
    regionCode?: string;
}

export interface ApiGeographyCreateCountryPostRequest {
    country?: Country;
}

export interface ApiGeographyCreateLocationPostRequest {
    location?: Location;
}

export interface ApiGeographyCreateRegionPostRequest {
    region?: Region;
}

export interface ApiGeographyGetAllCountriesGetRequest {
    pageNumber?: number;
    pageSize?: number;
    name?: string;
    code?: string;
}

export interface ApiGeographyGetAllLocationsGetRequest {
    pageNumber?: number;
    pageSize?: number;
    iataCode?: string;
    name?: string;
}

export interface ApiGeographyGetAllRegionsGetRequest {
    pageNumber?: number;
    pageSize?: number;
    code?: string;
    name?: string;
}

export interface ApiGeographyGetByCountryCodeCountryCodeGetRequest {
    countryCode: string;
}

export interface ApiGeographyGetByCountryIdCountryIdGetRequest {
    countryId: string;
}

export interface ApiGeographyGetByLocationCodeLocationCodeGetRequest {
    locationCode: string;
}

export interface ApiGeographyGetByLocationIdLocationIdGetRequest {
    locationId: string;
}

export interface ApiGeographyGetByRegionCodeRegionCodeGetRequest {
    regionCode: string;
}

export interface ApiGeographyGetByRegionIdRegionIdGetRequest {
    regionId: string;
}

export interface ApiGeographyUpdateCountryPatchRequest {
    country?: Country;
}

export interface ApiGeographyUpdateLocationPatchRequest {
    location?: Location;
}

export interface ApiGeographyUpdateRegionPatchRequest {
    region?: Region;
}

export interface ApiGeographyValidateCountryPostRequest {
    country?: Country;
}

export interface ApiGeographyValidateLocationPostRequest {
    location?: Location;
}

export interface ApiGeographyValidateRegionPostRequest {
    region?: Region;
}

/**
 * no description
 */
export class GeographyApi extends runtime.BaseAPI {

    /**
     */
    async apiCommonGeographyBuildRuleFormDataGeoGetRaw(requestParameters: ApiCommonGeographyBuildRuleFormDataGeoGetRequest): Promise<runtime.ApiResponse<GeoFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.pointType !== undefined) {
            queryParameters['pointType'] = requestParameters.pointType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Common/Geography/BuildRuleFormDataGeo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GeoFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiCommonGeographyBuildRuleFormDataGeoGet(requestParameters: ApiCommonGeographyBuildRuleFormDataGeoGetRequest): Promise<GeoFormData> {
        const response = await this.apiCommonGeographyBuildRuleFormDataGeoGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiCommonGeographyListCountriesByRegionGetRaw(requestParameters: ApiCommonGeographyListCountriesByRegionGetRequest): Promise<runtime.ApiResponse<Array<CodeAndLabel>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.regionCode !== undefined) {
            queryParameters['regionCode'] = requestParameters.regionCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Common/Geography/ListCountriesByRegion`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CodeAndLabelFromJSON));
    }

    /**
     */
    async apiCommonGeographyListCountriesByRegionGet(requestParameters: ApiCommonGeographyListCountriesByRegionGetRequest): Promise<Array<CodeAndLabel>> {
        const response = await this.apiCommonGeographyListCountriesByRegionGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyBulkUploadCountriesPostRaw(): Promise<runtime.ApiResponse<BulkUploadDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/BulkUploadCountries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyBulkUploadCountriesPost(): Promise<BulkUploadDataResponse> {
        const response = await this.apiGeographyBulkUploadCountriesPostRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyBulkUploadLocationsPostRaw(): Promise<runtime.ApiResponse<BulkUploadDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/BulkUploadLocations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyBulkUploadLocationsPost(): Promise<BulkUploadDataResponse> {
        const response = await this.apiGeographyBulkUploadLocationsPostRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyBulkUploadRegionsPostRaw(): Promise<runtime.ApiResponse<BulkUploadDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/BulkUploadRegions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUploadDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyBulkUploadRegionsPost(): Promise<BulkUploadDataResponse> {
        const response = await this.apiGeographyBulkUploadRegionsPostRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyCreateCountryPostRaw(requestParameters: ApiGeographyCreateCountryPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/CreateCountry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters.country),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiGeographyCreateCountryPost(requestParameters: ApiGeographyCreateCountryPostRequest): Promise<string> {
        const response = await this.apiGeographyCreateCountryPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyCreateLocationPostRaw(requestParameters: ApiGeographyCreateLocationPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/CreateLocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocationToJSON(requestParameters.location),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiGeographyCreateLocationPost(requestParameters: ApiGeographyCreateLocationPostRequest): Promise<string> {
        const response = await this.apiGeographyCreateLocationPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyCreateRegionPostRaw(requestParameters: ApiGeographyCreateRegionPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/CreateRegion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegionToJSON(requestParameters.region),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiGeographyCreateRegionPost(requestParameters: ApiGeographyCreateRegionPostRequest): Promise<string> {
        const response = await this.apiGeographyCreateRegionPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetAllCountriesGetRaw(requestParameters: ApiGeographyGetAllCountriesGetRequest): Promise<runtime.ApiResponse<CountryListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetAllCountries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetAllCountriesGet(requestParameters: ApiGeographyGetAllCountriesGetRequest): Promise<CountryListBusinessDataResponse> {
        const response = await this.apiGeographyGetAllCountriesGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetAllLocationsGetRaw(requestParameters: ApiGeographyGetAllLocationsGetRequest): Promise<runtime.ApiResponse<LocationListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.iataCode !== undefined) {
            queryParameters['iataCode'] = requestParameters.iataCode;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetAllLocations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LocationListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetAllLocationsGet(requestParameters: ApiGeographyGetAllLocationsGetRequest): Promise<LocationListBusinessDataResponse> {
        const response = await this.apiGeographyGetAllLocationsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetAllRegionsGetRaw(requestParameters: ApiGeographyGetAllRegionsGetRequest): Promise<runtime.ApiResponse<RegionListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetAllRegions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetAllRegionsGet(requestParameters: ApiGeographyGetAllRegionsGetRequest): Promise<RegionListBusinessDataResponse> {
        const response = await this.apiGeographyGetAllRegionsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetAllStationLocationGetRaw(): Promise<runtime.ApiResponse<StationOrLocationListBusinessDataResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetAllStationLocation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StationOrLocationListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetAllStationLocationGet(): Promise<StationOrLocationListBusinessDataResponse> {
        const response = await this.apiGeographyGetAllStationLocationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyGetByCountryCodeCountryCodeGetRaw(requestParameters: ApiGeographyGetByCountryCodeCountryCodeGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.countryCode === null || requestParameters.countryCode === undefined) {
            throw new runtime.RequiredError('countryCode','Required parameter requestParameters.countryCode was null or undefined when calling apiGeographyGetByCountryCodeCountryCodeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByCountryCode/{countryCode}`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters.countryCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyGetByCountryCodeCountryCodeGet(requestParameters: ApiGeographyGetByCountryCodeCountryCodeGetRequest): Promise<void> {
        await this.apiGeographyGetByCountryCodeCountryCodeGetRaw(requestParameters);
    }

    /**
     */
    async apiGeographyGetByCountryIdCountryIdGetRaw(requestParameters: ApiGeographyGetByCountryIdCountryIdGetRequest): Promise<runtime.ApiResponse<CountryListBusinessDataResponse>> {
        if (requestParameters.countryId === null || requestParameters.countryId === undefined) {
            throw new runtime.RequiredError('countryId','Required parameter requestParameters.countryId was null or undefined when calling apiGeographyGetByCountryIdCountryIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByCountryId/{countryId}`.replace(`{${"countryId"}}`, encodeURIComponent(String(requestParameters.countryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetByCountryIdCountryIdGet(requestParameters: ApiGeographyGetByCountryIdCountryIdGetRequest): Promise<CountryListBusinessDataResponse> {
        const response = await this.apiGeographyGetByCountryIdCountryIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetByLocationCodeLocationCodeGetRaw(requestParameters: ApiGeographyGetByLocationCodeLocationCodeGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.locationCode === null || requestParameters.locationCode === undefined) {
            throw new runtime.RequiredError('locationCode','Required parameter requestParameters.locationCode was null or undefined when calling apiGeographyGetByLocationCodeLocationCodeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByLocationCode/{locationCode}`.replace(`{${"locationCode"}}`, encodeURIComponent(String(requestParameters.locationCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyGetByLocationCodeLocationCodeGet(requestParameters: ApiGeographyGetByLocationCodeLocationCodeGetRequest): Promise<void> {
        await this.apiGeographyGetByLocationCodeLocationCodeGetRaw(requestParameters);
    }

    /**
     */
    async apiGeographyGetByLocationIdLocationIdGetRaw(requestParameters: ApiGeographyGetByLocationIdLocationIdGetRequest): Promise<runtime.ApiResponse<LocationListBusinessDataResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling apiGeographyGetByLocationIdLocationIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByLocationId/{locationId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LocationListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetByLocationIdLocationIdGet(requestParameters: ApiGeographyGetByLocationIdLocationIdGetRequest): Promise<LocationListBusinessDataResponse> {
        const response = await this.apiGeographyGetByLocationIdLocationIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetByRegionCodeRegionCodeGetRaw(requestParameters: ApiGeographyGetByRegionCodeRegionCodeGetRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.regionCode === null || requestParameters.regionCode === undefined) {
            throw new runtime.RequiredError('regionCode','Required parameter requestParameters.regionCode was null or undefined when calling apiGeographyGetByRegionCodeRegionCodeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByRegionCode/{regionCode}`.replace(`{${"regionCode"}}`, encodeURIComponent(String(requestParameters.regionCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyGetByRegionCodeRegionCodeGet(requestParameters: ApiGeographyGetByRegionCodeRegionCodeGetRequest): Promise<void> {
        await this.apiGeographyGetByRegionCodeRegionCodeGetRaw(requestParameters);
    }

    /**
     */
    async apiGeographyGetByRegionIdRegionIdGetRaw(requestParameters: ApiGeographyGetByRegionIdRegionIdGetRequest): Promise<runtime.ApiResponse<RegionListBusinessDataResponse>> {
        if (requestParameters.regionId === null || requestParameters.regionId === undefined) {
            throw new runtime.RequiredError('regionId','Required parameter requestParameters.regionId was null or undefined when calling apiGeographyGetByRegionIdRegionIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetByRegionId/{regionId}`.replace(`{${"regionId"}}`, encodeURIComponent(String(requestParameters.regionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionListBusinessDataResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetByRegionIdRegionIdGet(requestParameters: ApiGeographyGetByRegionIdRegionIdGetRequest): Promise<RegionListBusinessDataResponse> {
        const response = await this.apiGeographyGetByRegionIdRegionIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyGetCountryFormConfigurationGetRaw(): Promise<runtime.ApiResponse<CountryFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetCountryFormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetCountryFormConfigurationGet(): Promise<CountryFormConfiguration> {
        const response = await this.apiGeographyGetCountryFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyGetRegionFormConfigurationGetRaw(): Promise<runtime.ApiResponse<RegionFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/GetRegionFormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegionFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyGetRegionFormConfigurationGet(): Promise<RegionFormConfiguration> {
        const response = await this.apiGeographyGetRegionFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGeographyUpdateCountryPatchRaw(requestParameters: ApiGeographyUpdateCountryPatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/UpdateCountry`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters.country),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyUpdateCountryPatch(requestParameters: ApiGeographyUpdateCountryPatchRequest): Promise<void> {
        await this.apiGeographyUpdateCountryPatchRaw(requestParameters);
    }

    /**
     */
    async apiGeographyUpdateLocationPatchRaw(requestParameters: ApiGeographyUpdateLocationPatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/UpdateLocation`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LocationToJSON(requestParameters.location),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyUpdateLocationPatch(requestParameters: ApiGeographyUpdateLocationPatchRequest): Promise<void> {
        await this.apiGeographyUpdateLocationPatchRaw(requestParameters);
    }

    /**
     */
    async apiGeographyUpdateRegionPatchRaw(requestParameters: ApiGeographyUpdateRegionPatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/UpdateRegion`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RegionToJSON(requestParameters.region),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGeographyUpdateRegionPatch(requestParameters: ApiGeographyUpdateRegionPatchRequest): Promise<void> {
        await this.apiGeographyUpdateRegionPatchRaw(requestParameters);
    }

    /**
     */
    async apiGeographyValidateCountryPostRaw(requestParameters: ApiGeographyValidateCountryPostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/ValidateCountry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CountryToJSON(requestParameters.country),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyValidateCountryPost(requestParameters: ApiGeographyValidateCountryPostRequest): Promise<ValidationErrors> {
        const response = await this.apiGeographyValidateCountryPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyValidateLocationPostRaw(requestParameters: ApiGeographyValidateLocationPostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/ValidateLocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocationToJSON(requestParameters.location),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyValidateLocationPost(requestParameters: ApiGeographyValidateLocationPostRequest): Promise<ValidationErrors> {
        const response = await this.apiGeographyValidateLocationPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGeographyValidateRegionPostRaw(requestParameters: ApiGeographyValidateRegionPostRequest): Promise<runtime.ApiResponse<ValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Geography/ValidateRegion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegionToJSON(requestParameters.region),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiGeographyValidateRegionPost(requestParameters: ApiGeographyValidateRegionPostRequest): Promise<ValidationErrors> {
        const response = await this.apiGeographyValidateRegionPostRaw(requestParameters);
        return await response.value();
    }

}
